import { useQueryClient } from '@tanstack/react-query'

import {
  useIndividualsServicePostV1IndividualsByIndividualIdDocuments,
} from '../client/queries'
import {
  useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey,
  useIndividualsServiceGetV1IndividualsByIndividualIdKey,
} from '../client/queries/common'

export const useCreateDocuments = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePostV1IndividualsByIndividualIdDocuments({
    onSuccess: (_, { requestBody }) => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })

      if (requestBody.some(doc => doc.errand)) {
        queryClient.invalidateQueries({
          queryKey: [useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey],
        })
      }
    },
  })
}
